<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 5s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes jl-01 {
    0% {
      opacity: 1;
    }
    20%,
    80% {
      opacity: 0;
    }
    80%,
    100% {
      opacity: 1;
    }
  }
  #jl-01 {
    animation-name: jl-01;
  }
  @keyframes jl-02 {
    0% {
      opacity: 0;
    }
    20%,
    40% {
      opacity: 1;
    }
    40%,
    100% {
      opacity: 0;
    }
  }
  #jl-02 {
    animation-name: jl-02;
  }
  @keyframes jl-03 {
    0% {
      opacity: 0;
    }
    40%,
    60% {
      opacity: 1;
    }
    60%,
    100% {
      opacity: 0;
    }
  }
  #jl-03 {
    animation-name: jl-03;
  }
  @keyframes jl-04 {
    0% {
      opacity: 0;
    }
    60%,
    80% {
      opacity: 1;
    }
    80%,
    100% {
      opacity: 0;
    }
  }
  #jl-04 {
    animation-name: jl-04;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 581.8 928.3" height="100%" width="100%">
<g class:paused={isPaused}>
  <g class="shapes" bind:this={rootElement}>
    <g id="jl-01">
      <path fill="var(--shirt)" d="M95 496Z" />
      <path fill="var(--hair)" d="M36 284Z" />
      <path
        fill="var(--hair)"
        d="M117 851c2-2 4-4 3-8-1-3-4-5-7-5-4 0-8-2-12-4a187 187 0 0 1-27-16c-4-3-7-5-7-10 0-2 0-6-5-3a3 3 0 0 1-1 0c-2 0-2 3-3 4 2 5 0 8-5 10l-1 8c-4 3-9 5-12 10-4 8-13 5-18-4l-4-7c-2 0-3-1-3-3s1-3 3-3a1 1 0 0 1 1 0c-1-1-1-4-3-3a4 4 0 0 0-3 4c0 6-1 12 1 17v11a6 6 0 0 0 2-2 6 6 0 0 1-2 2c1 4-1 8 1 12a3 3 0 0 0 3 3c5 3 11 4 17 5a2 2 0 0 0 3 1h4l8 3 2 1 12 5 4 1c6 2 13 2 19 1 9-1 17-3 24-8 6-4 8-10 4-15-3-4-1-5 2-7Zm-101-6a7 7 0 0 0-1-1 7 7 0 0 1 1 1Zm0 2a3 3 0 0 0 0-1 3 3 0 0 1 0 1Z"
      />
      <path fill="var(--shirt)" d="M110 525ZM111 526Z" />
      <path
        fill="var(--pants)"
        d="m102 593-4-1c1-7-8-12-5-21a29 29 0 0 0-4-27c-4-5-4-11-5-17l-8 1-18 3-30 6c-8 3-15 3-21-3-1 12 0 24 4 35 8 24 11 49 11 74 0 12 0 12 12 13 19 1 37-2 56-2 11-2 11-2 13-14l2-10c1-12 0-24 2-36-1 0-2-6-5-1Z"
      />
      <path
        fill="var(--hair)"
        d="M102 213c-3-4-7-3-11-3-3 0-7 1-9-2H53c-3 4-8 3-12 4-14 3-23 13-22 29s4 29 8 43a4 4 0 0 0 2 5c3 0 6-1 7-5 7-6 2-13 1-20-1-5-1-9 3-12 6-1 10 2 12 7 2 8 6 9 12 3a16 16 0 0 0 2-3l2-4c1-5 2-10 8-13 3-1 4-5 3-8-1-8 2-11 9-8l8 4 2-3a26 26 0 0 0 2-3c2-4 4-7 2-11Z"
      />
      <path
        fill="var(--hair)"
        d="M18 826c-2 0-3-1-3-3s1-3 3-3v2h-1a6 6 0 0 0 1 1v2Z"
      />
      <path
        fill="var(--pants)"
        d="M18 825v-2l1 1a9 9 0 0 0-1 0 2 2 0 0 0 0 1Z"
      />
      <path
        fill="var(--pants)"
        d="M18 823a6 6 0 0 1-1-1h1a1 1 0 0 1 0 1Z"
      />
      <path
        fill="var(--shirt)"
        d="M108 504c-6-35-7-70-5-106 0-9 0-18-5-27-2-9-6-17-11-25-1-4-3-7-6-10a38 38 0 0 0-8-13l-2-4c-3 1-3 3-3 6 0 5-3 7-7 4l-9-1c-5-7-12-9-19-11l-9-12c-7 6-9 15-13 23-4 6-5 14-11 20v27a178 178 0 0 1 12 86c-1 10 0 21-4 31-5 14-3 28-1 42 6 6 13 6 21 3l30-6c6-2 12-3 18-2l8-2a17 17 0 0 0-6-11c-9-8-14-18-24-26-6-5-9-13-12-21-3-4-4-9-5-13l-1-1v-5l-1-4-4-18-3-25c-2-2 0-5-1-8a44 44 0 0 1 1-12c11 3 22 1 33 2 3 0 6-2 7 2a7 7 0 0 0 1 0 7 7 0 0 1-1 0v34c0 4 0 9 3 13 4 5 4 12 7 18 2 3 4 7 4 11 3 0 1 5 4 6l1 3v5c5 3 5 8 6 13 3 1 2 4 2 6 2 0 3 1 3 3v2c4 3 4 7 5 11s2 7 6 8c2-5 0-10-1-16Z"
      />
      <path
        fill="var(--flesh)"
        d="m122 544-11-18-1-1-1-5c-4-1-5-4-6-8s-1-8-5-11v-2a2 2 0 0 1-3-2 2 2 0 0 0 3 2l-3-7c0-2-5-14-7-16-2-11-8-21-13-31l-4-11c-3-4-3-9-3-13v-34c-1-4-4-2-7-2-11-1-22 1-33-2a44 44 0 0 0-1 12 4 4 0 0 1 1 2 4 4 0 0 0-1 3c2 14 2 28 5 41l5 20c1 5 3 9 7 12 2 6 5 13 10 17 10 8 15 18 24 26a17 17 0 0 1 6 11c1 6 1 12 5 17a29 29 0 0 1 4 27c-3 9 6 14 5 21l4 1c3-5 4 1 5 1 7 1 6-6 9-9 1 2 0 5 3 6 3 0 3-4 4-6l3-13c1-10 1-19-4-28ZM24 701a56 56 0 0 0-4 9c-3 8-8 16-7 25l4 49c1 12 3 24 2 36a1 1 0 0 0-1 0v2a1 1 0 0 1 0 1l1 1a9 9 0 0 0-1 0 2 2 0 0 0 0 1v1l4 7c5 9 14 12 18 4 3-5 8-7 12-10l1-8c5-2 7-5 5-10 1-1 1-4 3-4v-8l-1-4c2-14-1-28 0-42v-5c2-2 1-4 1-6 2-11 1-23 7-31 11-17 16-36 22-55-19 0-37 3-56 2 2 16 0 31-10 45Zm-2 132v-3 3Zm36-30a8 8 0 0 0-1 1v1-1a8 8 0 0 1 1-1 13 13 0 0 1 0-1 13 13 0 0 0 0 1Zm5-91-2-4 2 4Zm-2-4a5 5 0 0 0-3-1 5 5 0 0 1 3 1ZM18 823ZM29 289c-2 5-1 11-5 16l9 12c7 2 14 4 19 11l9 1c4 3 7 1 7-4 0-3 0-5 3-6-2-10 4-17 14-16 5 1 11 2 12-3 1-7 7-13 6-21a4 4 0 0 1 2-4c4-3 3-7 0-11-2-3-6-5-5-9 2-9-3-17-4-25l-8-4c-7-3-10 0-9 8 1 3 0 7-3 8-6 3-7 8-8 13l-2 4a15 15 0 0 1-2 3c-6 6-10 5-12-2-2-6-6-9-12-8-4 3-4 7-3 12 1 7 6 14-1 21-1 3-4 4-7 4Z"
      />
    </g>
    <g id="jl-02">
      <path
        fill="var(--hair)"
        d="M493 823c-6 7-13 10-22 11-17 2-34 3-52 1l-31-2c-2-1-5 0-4-4 3-12 3-25 9-36 1-1 1-4 4-2l7 8c3 2 6 6 9 3 4-3 12-4 10-12-1-6 1-9 7-10 2 2 2 4 2 6 0 9 6 13 13 17 13 5 26 13 41 13 2-1 4 2 7 3ZM68 842c1 5-2 4-4 4-6 0-6 2-7 7 0 6 0 11 7 13 4 1 7 4 11 6 2 1 2 4 2 6 0 3-2 5-4 5l-15 4H46l-1-1c-16-3-23-14-25-30-1-9-5-18-7-27-3-12 2-18 14-18 5 0 10 2 15 1l1 3-2 4c-5 3-8 7-4 13 3 5 15 10 19 7 5-2 9 0 12 3Z"
      />
      <path
        fill="var(--pants)"
        d="M382 660a173 173 0 0 0-13 29c-3 4-3 9-7 12l-3-4-9-29c-3-9-5-18-10-26h-1v-4c4-6 7-12 14-15 4 1 8 3 13 0 2-2 4 1 6 2 6 2 11 8 19 3 2-2 7 1 8 5-4 1-5 4-6 6-3 6-8 12-9 19l-2 2Z"
      />
      <path
        fill="var(--shirt)"
        d="M344 541a7 7 0 0 1-3-4 7 7 0 0 0 3 4c1-7-2-13-4-20-5-15-18-25-27-38a15 15 0 0 0-8-6c-2-2-4-3-7-3-2-5-8-8-12-10-8-3-15-8-23-9-7 10-14 20-19 31-10 23-9 46-5 70l10 47c1 6 2 12 0 18-4 10-10 21-12 32-1 7-6 13-4 21l14 4c13 2 26 7 40 8 12 2 22 0 30-10 0-4-4-6-7-9-2-4-4-7-3-11l-1-3c-5-7-9-15-12-24a3 3 0 0 1 0-2c-1-6-7-10-7-17l-10-30c-1-4 6-13 11-14 8 0 15 1 22-2 6-3 9 3 9 7 1 6 4 11 4 17a36 36 0 0 1 5 19v3c5 5 2 11 3 16 3 1 2 4 3 6a8 8 0 0 0 5 6c4-6 7-12 14-15-1-27-6-55-9-82Zm-3-8v2-2Z"
      />
      <path
        fill="var(--pants)"
        d="m329 689-1-2-3-2-8-9c-8 10-18 12-30 10-14-1-27-6-40-8-1 3-3 2-5 2 1-3 3-2 5-2l-14-4a42 42 0 0 0 3 23c0 4-7 10 1 14l-1 5-8 25-7 19c-2 6-6 12-6 19 9 8 18 13 29 15h24a72 72 0 0 1 30-7c6 0 8-3 9-8 1-16 1-31 4-47 4-14 10-27 28-26-1-7-8-11-10-17Z"
      />
      <path
        fill="var(--hair)"
        d="M332 363h-9c-16-3-31-1-47 2-13 2-19 13-20 23-1 18 5 36 10 54 3-1 6-3 8-6 5-7 0-14-1-20-1-9 1-12 10-12 3 3 6 6 6 10 1 4 3 5 6 3 6-2 10-6 10-13 1-4 2-7 6-9 5-2 6-6 4-10-1-5 1-8 7-8a50 50 0 0 1 6 2l4 3a26 26 0 0 0 6-10c3-6 0-9-6-9Z"
      />
      <path fill="var(--pants)" d="M247 678c-1 3-3 2-5 2 1-3 3-2 5-2Z" />
      <path
        fill="var(--flesh)"
        d="m215 779-3 6c-2 7-6 13-9 20-2 4-5 7-11 6l-9-2c-17-3-35-6-52-3-27 5-53 9-80 8l-8 1-2 4c-5 3-8 7-4 13 3 5 15 10 19 7 5-2 9 0 12 3l8-1a102 102 0 0 1 34 3c34 9 69 7 104 10 11 1 19-4 23-13s11-16 17-23c5-7 11-15 14-23l-24-1c-11-2-20-7-29-15ZM441 642l-42-9c-4 1-5 4-6 6v8-8c-3 6-8 12-9 19l-2 2a173 173 0 0 0-13 29 303 303 0 0 0 39 2c4 0 5 1 3 5a63 63 0 0 0-4 15c-3 18-1 38-5 56-2 8-2 16-5 24l7 8c3 2 6 6 9 3 4-3 12-4 10-12-1-6 1-9 7-10-1-10 3-20 6-29l7-18 19-49c8-18-2-38-21-42Zm-50 19a2 2 0 0 0-3-2 2 2 0 0 1 3 2ZM341 427c5-4 3-7 0-11-2-3-5-6-5-10 1-9-2-16-4-24l-4-3a50 50 0 0 0-6-2c-6 0-8 3-6 8 1 4 0 8-5 11-4 1-5 4-6 8 0 7-4 11-10 13-3 2-5 1-6-3 0-4-2-8-6-10-9 0-11 3-10 12 1 6 6 13 1 20-2 3-5 5-8 6-2 4-2 8-3 13 8 1 15 6 23 9 4 2 10 5 12 10 3 0 5 1 7 3l1-7c2-11 6-15 17-15h4c5 0 8-2 8-6 0-7 8-13 4-21l2-1Z"
      />
      <path
        fill="var(--flesh)"
        d="M372 723c-6-6-9-13-10-22l-3-4-9-29c-3-9-5-18-10-26h-1v-4a8 8 0 0 1-5-6c-1-2 0-5-3-6-1-5 2-11-3-16v-3a36 36 0 0 0-5-19c0-6-3-11-4-17 0-4-3-10-9-7-7 3-14 2-22 2-5 1-12 10-11 14l10 30c0 7 6 11 7 18a3 3 0 0 0 0 1c3 9 7 17 12 24l1 3c-1 4 1 7 3 11 3 3 7 5 7 9l8 9 3 2 1 2c2 6 9 10 10 17a29 29 0 0 1 8 19c1 7 2 15 8 21 5 5 6 12 2 19-3 5 0 6 4 8 3 3 5 0 8 0 9-1 18-14 18-22 0-12-6-20-15-28Zm-12 5a1 1 0 0 1 0 1 1 1 0 0 0 0-1Z"
      />
    </g>
    <g id="jl-04">
      <path
        fill="var(--flesh)"
        d="m438 738-42-10c-4 1-5 4-6 6v8-8c-3 6-7 12-9 19l-2 2a173 173 0 0 0-14 29 305 305 0 0 0 40 2c3 0 4 1 3 5a63 63 0 0 0-4 15c-3 19-2 38-6 56-2 8-2 16-5 24l6 9c2 3 7 5 10 2 4-3 12-4 10-12-1-6 1-9 7-10-1-10 3-19 7-29l7-17 19-50c8-18-2-37-21-41Zm-50 18a2 2 0 0 0-3-2 2 2 0 0 1 3 2ZM265 830l2-43c-1-3-4-3-7-4-2 1-5 2-7 1 2 1 5 0 7-1-6-2-13-6-20-6l-2-1a174 174 0 0 0-31-9 302 302 0 0 0 5 39c0 4 0 5-4 4a63 63 0 0 0-16-1c-19 0-37 5-56 4-8 0-48 2-56 0a100 100 0 0 0-8 9c-2 2-4 7-1 9 4 3 6 11 14 8 5-2 32 3 47 3s16 0 25 2l19 4 52 10c19 5 37-8 37-28Zm-27-46a2 2 0 0 0 2-3 2 2 0 0 1-2 3Z"
      />
      <path
        fill="var(--pants)"
        d="M356 702c-7-3-16-5-23-9a5 5 0 0 1-2-2l-8-2c-7 3-10 9-14 14v5c6 7 8 17 11 25l9 30 3 4c-9 23-8 48 24 27 17-2 24 3 29-7l5-42c1-7 9-14 13-20l-40-20-7-3Z"
      />
      <path
        fill="var(--shirt)"
        d="M314 606a7 7 0 0 1-3-4 7 7 0 0 0 3 4c1-7-2-13-4-19-6-15-18-26-27-39a15 15 0 0 0-8-5c-2-2-4-4-7-3-2-6-8-8-12-10-8-3-15-8-23-9-7 10-14 20-19 31-11 23-9 46-5 70l10 47c1 6 2 12 0 17-4 11-10 22-12 33-2 7-6 13-4 21l13 3c14 3 27 8 40 9 13 2 23 0 31-10-1-5-4-7-7-10s-4-6-4-10v-3c-5-7-10-15-12-24a3 3 0 0 1 0-2c-1-6-7-11-7-17l-10-30c-2-4 6-13 11-14 7-1 15 1 22-2 5-3 8 2 9 6 1 6 4 12 3 18 4 6 6 12 6 19v3c5 4 2 10 3 16 3 1 2 3 2 5a8 8 0 0 0 6 6c4-5 7-11 14-14-1-28-7-55-9-83Zm-4-7Z"
      />
      <path
        fill="var(--pants)"
        d="M202 765v22c26 8 54 7 75 3 30 4 80 19 31-19-1-6-7-10-9-16l-2-2-2-2-8-9c-8 10-18 12-31 10-13-1-26-6-40-8 0 3-2 2-5 2 2-3 4-2 5-2l-13-4-1 22v3Z"
      />
      <path
        fill="var(--hair)"
        d="m301 428-8 1c-16-3-32-2-47 1-13 3-19 14-20 23-1 19 5 37 10 54 3 0 5-3 7-5 6-7 1-14 0-21-1-8 1-12 10-11 3 2 6 6 6 10 1 4 3 5 6 3 5-2 10-6 10-13 0-4 2-7 6-9 5-2 6-6 4-11-1-4 1-7 6-7a50 50 0 0 1 7 2l4 3a26 26 0 0 0 6-10c2-6 0-10-7-10Z"
      />
      <path fill="var(--pants)" d="M216 744c0 3-2 2-5 1 2-2 4-1 5-1Z" />
      <path
        fill="var(--flesh)"
        d="M311 492c5-3 3-6 0-10-2-3-5-6-5-11 1-8-2-16-4-23l-4-3a50 50 0 0 0-7-2c-5 0-7 3-6 8 2 4 1 8-4 10-4 2-6 5-6 9 0 7-5 11-10 13-3 2-5 1-6-3 0-4-3-8-6-10-9-1-11 3-10 12 1 6 6 13 0 20-2 2-4 5-7 5-2 4-2 9-3 14 8 1 15 6 23 9 4 2 10 4 12 10 3-1 5 1 7 3l1-7c1-11 5-15 17-15h4c5 0 7-2 8-7 0-7 7-12 4-20l2-2ZM342 789c-6-6-9-13-10-22l-3-4-9-30c-3-8-5-18-11-25v-5a8 8 0 0 1-6-6c0-2 1-4-2-5-1-5 2-12-3-16v-3c0-7-2-13-6-19 1-6-2-11-3-18-1-4-4-9-9-6-7 3-15 1-22 2-5 1-13 10-11 14l10 30c0 6 6 11 7 17a3 3 0 0 0 0 2c2 9 7 17 12 24v3c0 4 1 7 4 11 3 2 6 4 7 9l8 9 2 2 2 2c2 6 8 10 9 16a29 29 0 0 1 9 19c1 8 2 15 7 21 6 6 7 13 3 20-3 4 0 6 4 7 2 4 5 0 8 0 8 0 18-13 18-21 0-12-7-20-15-28Zm-12 5a1 1 0 0 1-1 1 1 1 0 0 0 1-1Z"
      />
      <path
        fill="var(--hair)"
        d="M113 841c1 4-3 4-5 3-5 0-6 3-6 7-1 6-1 11 6 13 4 1 7 4 11 6 3 2 3 4 3 6 0 3-2 5-5 5l-15 4H90v-1c-17-3-23-14-25-30-1-9-5-18-8-27-3-12 2-18 14-18 5 0 10 2 15 1l2 3-3 4c-4 3-7 7-3 13 3 5 14 10 19 8 5-3 8-1 12 3ZM497 914c-6 8-14 12-24 13-19 1-38 2-57 0l-35-2c-2 0-5 0-4-4 4-13 3-27 10-40 1-1 1-4 4-2l7 9c2 3 7 6 11 3 4-4 13-5 11-13-1-7 1-10 8-11 2 1 2 4 2 6 0 11 6 15 14 19 15 5 28 14 45 14 3 0 5 2 8 4Z"
      />
    </g>
    <g id="jl-03">
      <path
        fill="var(--hair)"
        d="M448 0c20 8 38 19 53 35a18 18 0 0 0 3 2c4 3 9 4 8 10s-7 8-12 9c-6-10-8-21-17-30-9-8-18-11-28-14-12-4-26 0-34 10-1 2-2 5-6 4 5-11 11-20 24-24 0 0 2 0 1-2Z"
      />
      <path
        fill="var(--shirt)"
        d="m416 125 9 13c0 10 6 19 7 28v12c-4-1-7-5-9-8-8-12-18-20-34-18h-10a24 24 0 0 0-16 7c-7 7-5 23 3 25 12 4 18 15 25 23 4 5 8 9 15 11 5 1 11 2 15 6-8 26-13 53-16 80l-3 30c0 5-4 5-8 6l-8-1c-24-3-49 7-72-7-9-5-19-9-24-19l-13-19c-1-4 1-7 4-11 14-15 23-34 32-53 9-18 12-38 14-59 1-23 7-46 23-64 9-10 22-17 35-21l1 5a225 225 0 0 1 18 27c2 4 5 9 12 7Z"
      />
      <path
        d="m277 294 13 19c5 10 14 14 24 19 23 14 48 4 72 7l8 1 3 93c0 6 2 13-4 18-14 2-28 7-43-1-9-5-19-5-29-1-6 2-7-4-9-8-4 3-4 6-5 9-1 4-3 5-7 3-11-6-24-7-36-11-7-3-15-8-20 2-7-5-7-11-4-18l11-26c9-20 11-42 13-64 1-14 5-29 13-42Z"
        fill="var(--pants)"
      />
      <path
        fill="var(--flesh)"
        d="M321 449c10-4 20-4 29 1 15 8 29 3 43 1 1 13 4 26 1 39a12 12 0 0 0 0 4c5 30 0 60 8 90 7 24 10 49 20 72 2 7 4 13 11 17-5 12-21 14-29 5l-10-14c-1-9-6-16-9-24-6-13-12-26-20-38-10-13-8-28-6-42 1-12 1-23-3-34-9-22-17-44-29-64a32 32 0 0 1-6-13ZM244 444c5-9 13-5 20-2 12 4 25 5 36 11a73 73 0 0 0-6 20c-1 11-8 18-19 21-33 8-62 26-91 43a212 212 0 0 0-32 24c-4 3-7 6-8 11-3 1-5 5-9 2-8-4-9-16-2-21 6-4 5-8 0-12 16-17 34-32 47-52 11-17 29-23 48-27 10-3 14-8 16-18ZM421 224c-4-4-10-5-15-6-7-1-11-6-15-11-7-8-13-19-25-23-8-2-10-18-3-25a24 24 0 0 1 17-7h9c16-2 26 6 34 18 2 3 5 7 9 8 8 9 20 12 29 19l23 14c25 15 51 26 76 41a47 47 0 0 1 7 4c2 2 3 4 0 6-10 8-18 12-30 4a88 88 0 0 0-26-11 72 72 0 0 1-28-16c-4-3-11-3-16-4l-46-11ZM416 125c-7 2-10-3-12-7a225 225 0 0 0-17-27l-2-5c2-6 8-9 11-14l11 1c15 2 21-2 27-17a31 31 0 0 1 1-4c2-5 10-8 15-5 5 2 5 7 3 12l-2 6c-1 2-2 4 0 5 3 2 6 2 7 1 6-9 17-13 21-22 3-7 7-6 11-2l8 10c-4 4-5 9-7 13-1 3-2 7-4 8-5 5-6 10-6 17 1 5 0 9-7 9-2 0-3 1-4 3-4 7-13 9-19 14-4 4-9-2-12-5-6-6-11-6-18-1-4 3-6 5-5 10ZM432 166c-1-9-7-18-7-28 30 0 58 7 87 14l6 1c9 6 18 3 26-2s15-3 22 0c5 1 2 3-1 4a35 35 0 0 0-4 2c4 1 8 3 10 2 7-1 8 5 10 8s-2 3-4 3c-7 0-15 0-22 2-2 1-5 1-5 3 0 3 3 3 5 3a25 25 0 0 1 10 3c2 1 4 3 3 5s-4 3-6 2c-11-4-24-3-33-13-2-3-6-4-10-4h-47c-8 1-17 1-24-3-5-2-11-1-16-2Z"
      />
      <path
        fill="var(--hair)"
        d="m394 664 10 14c8 9 24 7 29-5 1-1 1-4 3-4 3-1 3 2 4 4 1 3 2 5 5 7 11 6 22 15 34 19a19 19 0 0 1 3 1c5 3 14 3 12 11-1 8-8 10-15 11-12 2-23 0-35-2l-51-12c-6-1-11-3-8-12 2-7 3-15 7-22 2-2 1-5-1-7s1-3 3-3Z"
      />
      <path
        d="m498 57-9-10c-3-4-7-5-10 2-4 9-15 13-21 22-1 1-4 1-7-1-2-1-1-3 0-5l2-6c2-5 2-9-3-12s-13 0-15 5a31 31 0 0 0-1 4c-6 15-11 19-27 17l-11-1v-3l1-1 3-5c2-1 2-2 2-4l1-3c3-1 3-2 2-4l3-9c6-4 8-10 7-17 4 1 5-2 6-4 8-10 22-14 34-10 10 3 20 6 28 14 9 9 11 20 17 30Z"
        fill="var(--hair)"
      />
      <path
        fill="var(--hair)"
        d="M133 541c5 4 6 8 0 12-7 5-6 17 2 21 4 3 6-1 9-2 0 8-6 15-7 23-2 9-3 18-2 28 1 9-4 12-13 7-10-6-15-17-18-28a374 374 0 0 1-8-41c-2-10 1-13 11-16 8-3 17-2 26-4ZM415 26c1 7-1 13-7 17 1-6 3-12 7-17ZM405 52c1 2 1 3-2 4ZM402 59c0 2 0 3-2 4a4 4 0 0 1 2-4ZM397 68l-1 1 1-1Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>